import { Dispatch } from "react"
import { LandingActionTypes } from "../action-types";
import { LandingActions } from "../actions"
import { Landing } from "../../domain/landing/landing";

export const SendLandingListRequest = () => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_REQUEST_SEND,
          });
    }
}

export const LandingListSuccess = (list: Landing[]) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_SUCCESS,
            payload: list,
        });
    }
}

export const LandingListError = (error:string) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_ERROR,
            payload: error,
        });
    }
}

export const LandingCreateRequest = () => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_CREATE_REQUEST,
          });
    }
}

export const LandingCreateSuccess = (landing: Landing) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_CREATE_SUCCESS,
            payload: landing,
          });
    }
}

export const LandingCreateError = (message: string) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_CREATE_ERROR,
            payload: message,
          });
    }
}


export const LandingUpdateRequest = () => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_UPDATE_REQUEST,
          });
    }
}

export const LandingUpdateSuccess = (category: Landing) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_UPDATE_SUCCESS,
            payload: category,
          });
    }
}

export const LandingUpdateError = (message: string) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_UPDATE_ERROR,
            payload: message,
          });
    }
}


export const LandingDeleteRequest = () => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_DELETE_REQUEST,
          });
    }
}

export const LandingDeleteSuccess = (id: UniqueId) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_DELETE_SUCCESS,
            payload: id,
          });
    }
}

export const LandingDeleteError = (message: string) => {
    return async (dispatch: Dispatch<LandingActions>) => {
        dispatch({
            type: LandingActionTypes.LANDING_DELETE_ERROR,
            payload: message,
          });
    }
}